import React, { RefObject, useRef } from 'react';
import { components, ValueContainerProps } from 'react-select';
import cn from 'classnames';

import { Tooltip } from '@components/common';

import { useOnClickOutsideSelect as useOnClickOutside } from '@hooks/utils/useOnClickOutSide';

import { TSelectOptionType } from '@components/common/Select/Select.types';

export const ValueContainer = (
	props: ValueContainerProps<TSelectOptionType | unknown>,
	multiselectText: string,
	handleMenuClose: () => void,
	multiSelectWrapperRef: RefObject<HTMLDivElement>,
	isFilterStyle: boolean,
) => {
	const { getValue, children, hasValue, selectProps: { menuIsOpen } } = props;
	const selectedOptionsLength = getValue().length;
	const selectedOptions = (getValue() as TSelectOptionType)
		?.map((option: TSelectOptionType) => option?.label || '')
		.join(', ');
	const valueContainerRef = useRef(null);

	useOnClickOutside([valueContainerRef, multiSelectWrapperRef], () => {
		if (menuIsOpen) {
			handleMenuClose();
		}
	});

	return (
		<div ref={valueContainerRef}>
			<components.ValueContainer {...props}>
				{hasValue && !isFilterStyle && (
					<div className={cn({
						disabledText: props.isDisabled,
					})}>
						{selectedOptionsLength} {multiselectText}
					</div>
				)}
				{hasValue && isFilterStyle && selectedOptions && (
					<Tooltip
						content={selectedOptions}
						isDisabled={!selectedOptions || menuIsOpen}
					>
						<div className={cn('multiselectOptionsText', {
							disabledText: props.isDisabled,
						})}>
							{selectedOptions}
						</div>
					</Tooltip>
				)}
				{children}
			</components.ValueContainer>
		</div>
	);
};
